import React from 'react';

interface ProgressBarProps {
  percent: number;
  color?: string;
}

export const ProgressBar = React.memo(function ProgressBar({ percent, color }: ProgressBarProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="progress-track">
        <div className="progress-fill" style={{ background: color ?? 'var(--slate)', width: `${percent}%` }} />
      </div>
      <span className="progress-label">{percent}%</span>
    </div>
  );
});
